import { render, staticRenderFns } from "./CommentV2Icon.vue?vue&type=template&id=01560609&"
import script from "./CommentV2Icon.vue?vue&type=script&lang=js&"
export * from "./CommentV2Icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports